import React, { Component } from 'react';

import Loading from './Loading';

import * as constants from '../../config/constants/AppConstants';

import * as fn from '../../library/function';
import * as helper from '../../library/helper';
import * as util from '../../library/utilitys';

import * as Actions from '../actions/ActionCenter';

class EB01PrintContent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      Datasets: {},
      loading: true
    };
    this.updateState = this.setState.bind(this);
  }

  loadDatasets = async () => {
    let { id } = this.props;
    let sets = [
      { key: "course_eb_01", filter: [{ field: "id", value: id }] },
      { key: "benefits", filter: [{ field: "status", value: '0' }] },
      { key: "target_industries", filter: [{ field: "status", value: '0' }] },
      { key: "expenses_eb_01", filter: [{ field: 'course_eb_01_id', value: id }] },
      { key: "learning_result", filter: [{ field: 'course_eb_01_id', value: id }] },
      { key: "course_benefit", filter: [{ field: 'course_eb_01_id', value: id }] },
      { key: "training_details_eb_01", filter: [{ field: 'course_eb_01_id', value: id }] },
    ];

    await Actions.loadDatasets(this.updateState, sets);

    this.setState({loading: false});
  }

  initialize = async () => { await this.loadDatasets(); }

  componentDidMount = async () => { await this.initialize(); }

  componentDidUpdate = async () => { }

  render = () => {

    const { id } = this.props;

    let { Datasets } = this.state;
    let ds = Datasets;

    let eb = ds?.course_eb_01 || {};
    if (eb[0]) { eb = eb[0]; }
    eb = Object.fromEntries(Object.entries(eb).map(([key, value]) => [key, util.renderText(value)]));

    let benefits = ds?.benefits || [];

    let target_industries = ds?.target_industries || [];

    let expenses_eb_01 = ds?.expenses_eb_01 || [];
    let expenses = (ds.expenses_eb_01 || []).map(exp => Object.fromEntries(Object.entries(exp).map(([key, value]) => [key, util.renderText(value)])));
    let total_expenses = expenses_eb_01.reduce((sum, expense) => {
      return sum + Number(expense.budget_gen || 0);
    }, 0);

    let learning_result = (ds.learning_result || []).map(exp => Object.fromEntries(Object.entries(exp).map(([key, value]) => [key, util.renderText(value)])));

    let course_benefit = (ds.course_benefit || []).map(exp => Object.fromEntries(Object.entries(exp).map(([key, value]) => [key, util.renderText(value)])));

    let training_details_eb_01 = (ds.training_details_eb_01 || []).map(exp => Object.fromEntries(Object.entries(exp).map(([key, value]) => [key, util.renderText(value)])));

    return (
      this.state.loading ? (<Loading></Loading>)
      :
      (
      <div className="print-container">
          <>
            <div className="print-page">

                  <h5 className="text-end">EB-01 Version 1.1</h5>
                  <h6 className="text-end">แบบฟอร์มข้อเสนอหลักสูตรอบรมระยะสั้นตามแนวทางอีอีซีโมเดล</h6>
                  <h6 className="text-end mb-4">สำนักงานคณะกรรมการนโยบายเขตพัฒนาพิเศษภาคตะวันออก (สกพอ.)</h6>

                  <h4 className="text-center"><b>หลักสูตรการอบรมระยะสั้นตามแนวทางอีอีซีโมเดล</b></h4>

                  <div className="form-section">
                  
                          <p><b>1. ชื่อหลักสูตร</b> {util.printText(eb.name)}</p>

                          <p>
                              <b>2. สถานศึกษาผู้รับผิดชอบหลักสูตร</b> {util.printText(eb.academy_name)} 
                              <b>รหัส</b> {util.printText(eb.genAcademyCode)}
                          </p>
                          <p>
                              <b className="ms-6">ผู้ประสานงาน</b> {util.printText(eb.coordinator_name)} 
                              <b>โทร</b> {util.printText(eb.coordinator_contact)} 
                              <b>email</b> {util.printText(eb.coordinator_email)}
                          </p>

                          <p><b>3. ผู้ประกอบการที่ประสงค์เข้ารับการอบรม</b>{util.printText(eb.enterprise_name)}</p>
                          <ul className="checkbox-list mb-0">
                              {benefits.map(benefit => (
                                  <li key={benefit.id}>
                                      <span className="ms-6">
                                          {eb.benefits_id === benefit.id ? '✔' : '☐'}
                                      </span>
                                      <span className="ms-2">{benefit.name}</span>
                                  </li>
                              ))}
                         </ul>

                          <p><b>4. ตอบสนองต่ออุตสาหกรรมเป้าหมาย</b> (เลือกเพียง 1 อุตสาหกรรม)</p>
                          <div className="checkbox-grid mb-0">
                              {target_industries.map(industry => (
                                  <div key={industry.id}>
                                      <span>
                                          {eb.target_industries_id === industry.id ? '✔' : '☐'}
                                      </span>
                                      <span className="checkbox-label ms-2">{industry.name}</span>
                                  </div>
                              ))}
                          </div>

                          <p>
                              <b>5. จำนวนผู้เข้าอบรม</b> {util.printText(util.formatNumber(eb.batch_count))} <b className="me-2">รุ่น</b>
                              <b>รุ่นละ</b> {util.printText(util.formatNumber(eb.people_per_batch))} <b className="me-2">คน</b>
                              <b>รวมทั้งสิ้น</b> {util.printText(util.formatNumber(Number(eb.batch_count) * Number(eb.people_per_batch)))} <b>คน</b>
                          </p>

                          <p><b>6. กำหนดการฝึกอบรม</b> {util.printText(util.displayMonthYearRange(eb, 'training_start_month', 'training_start_year', 'training_end_month', 'training_end_year'))}</p>

                          <p><b>7. ระยะเวลาการฝึกอบรม</b> {util.printText(eb.training_duration)}</p>

                          <p>
                              <b>8. งบประมาณต่อรุ่น</b> {util.printText(util.formatNumber(eb.budget_per_batch))} <b className="me-2">บาท</b>
                              <b>งบประมาณรวมทั้งสิ้น</b> {util.printText(util.formatNumber(Number(eb.budget_per_batch) * Number(eb.batch_count)))} <b>บาท</b>
                          </p>

                            <table className="print-table-border mt-2 mb-2">
                                <thead>
                                    <tr>
                                    <th className="text-center text-14px" style={{ width: '70%' }}>หมวดค่าใช้จ่าย</th>
                                    <th className="text-center text-14px">งบประมาณต่อรุ่น (บาท)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {expenses.map(exp => (
                                    <tr key={exp.id}>
                                        <td className="text-14px">{exp.name}</td>
                                        <td className="text-14px text-end">{(util.formatNumber(exp.budget_gen))}</td>
                                    </tr>
                                    ))}
                                    <tr key={`total_expenses`}>
                                        <td className="text-14px text-end"><b>รวม</b></td>
                                        <td className="text-14px text-end"><b>{util.formatNumber(total_expenses)}</b></td>
                                    </tr>
                                </tbody>
                            </table>

                    </div>
              </div>

              <div className="print-page">
          
                    <div className="form-section">
            
                          <p><b>9. กลุ่มเป้าหมาย</b> {util.printText(eb.target_group)}</p>

                          <p><b>10. ที่มาและความสำคัญ</b></p>
                          <div className="ms-3">{util.printText(eb.course_importance)}</div>

                          <p><b>11. ผลลัพธ์การเรียนรู้ของหลักสูตร (Learning Outcomes)</b></p>
                          <ol className="mb-0">
                              {learning_result.map(lr => (
                                  <li key={lr.id}>
                                      <span>{util.printText(lr.name)}</span>
                                  </li>
                              ))}
                          </ol>

                          <p><b>12. ผลกระทบและประโยชน์ที่คาดว่าจะได้รับ (Impact)</b></p>
                          <ol className="mb-0">
                              {course_benefit.map(cb => (
                                  <li key={cb.id}>
                                      <span>{util.printText(cb.name)}</span>
                                  </li>
                              ))}
                          </ol>

                          <p><b>13. รายละเอียดการฝึกอบรม</b></p>
                            <table className="print-table-border mt-2 mb-4">
                                <thead>
                                    <tr>
                                        <th className="text-14px text-center" style={{ width: '5%' }}>ที่</th>
                                        <th className="text-14px text-center" style={{ width: '25%' }}>หัวข้อ</th>
                                        <th className="text-14px text-center" style={{ width: '40%' }}>Outcomes ที่เกี่ยวข้อง</th>
                                        <th className="text-14px text-center" style={{ width: '15%' }}>ระยะเวลาการอบรม<br></br>ภาคทฤษฏี (ชั่วโมง)</th>
                                        <th className="text-14px text-center" style={{ width: '15%' }}>ระยะเวลาการอบรม<br></br>ภาคปฏิบัติ (ชั่วโมง)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {training_details_eb_01.map((training, index) => (
                                        <tr key={training.id}>
                                            <td className="text-14px text-center">{index + 1}</td>
                                            <td className="text-14px align-top">{training.name}</td>
                                            <td className="text-14px align-top">{training.outcome}</td>
                                            <td className="text-14px text-center">{training.theory_time}</td>
                                            <td className="text-14px text-center">{training.workshop_time}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                    </div>
                </div>

                <div className="print-page">
                
                    <div className="form-section">

                        <p><b>คำรับรองของสถานศึกษา</b></p>
                        <ol className="text-list">
                            <li>ข้าพเจ้าขอรับรองว่า ข้อความในเอกสารฉบับนี้รวมถึงเอกสารหลักฐานที่ถูกอ้างถึงมีความถูกต้องและเป็นจริงทุกประการ</li>
                            <li>เมื่อได้รับการรับรองหลักสูตรแล้วสถานศึกษาจะมีการจัดทำข้อตกลงกับสถานประกอบการที่ส่งบุคลากรมาฝึกอบรมในการรับหรือให้บุคลากรเข้าทำงานในสถานประกอบการ</li>
                        </ol>

                        <p><b>ลงนามรับรองโดยผู้บริหารสถานศึกษาและสถานประกอบการ</b></p>
                        <div className="signature-grid-accurate mt-2 mb-4">
                            <div className="signature-box">
                                <p className="text-center">สถานศึกษาผู้รับผิดชอบหลักสูตร</p>
                                <p className="text-center" style={{minHeight: '80px'}}>{util.printText('     ')}</p>
                                <p className="text-center">( {util.printText(eb.academy_signer_name)} )</p>
                                <p className="text-center">ตำแหน่ง {util.printText(eb.academy_signer_position)}</p>
                                <p className="text-center">วัน/เดือน/ปี พ.ศ. {util.printText(util.convertDateToTextBE(eb.academy_sign_date))}</p>
                            </div>

                            <div className="signature-box">
                                <p className="text-center">ผู้ประกอบการที่ร่วมรับรอง</p>
                                <p className="text-center" style={{minHeight: '80px'}}>{util.printText('     ')}</p>
                                <p className="text-center">( {util.printText(eb.enterprise_signer_name)} )</p>
                                <p className="text-center">ตำแหน่ง {util.printText(eb.enterprise_signer_position)}</p>
                                <p className="text-center">วัน/เดือน/ปี พ.ศ. {util.printText(util.convertDateToTextBE(eb.enterprise_sign_date))}</p>
                            </div>
                        </div>

                        <div className="officer-box">
                            <p><strong>สำหรับเจ้าหน้าที่</strong></p>
                            <div className="checkbox-row d-flex align-items-center flex-wrap">
                              <div className="me-4 d-flex align-items-center">
                                <span>{['', '2'].includes(eb.status) ? '✔' : '☐'  }</span>
                                <span className="checkbox-label ms-2">ไม่อนุมัติ</span>
                              </div>

                              <div className="me-4 d-flex align-items-center">
                                <span>{['0', '1'].includes(eb.status) ? '✔' : '☐'}</span>
                                <span className="checkbox-label ms-2">อนุมัติ</span>
                              </div>

                              <div>
                                รหัสหลักสูตร {util.printText(eb.official_course_code)}
                              </div>
                            </div>
                            <p>วันที่ {util.printText(util.convertDateToTextBE(eb.office_sign_date))}</p>
                            <p>ลงชื่อ {util.printText(eb.office_signer_name)}</p>
                        </div>

                    </div>

                </div>
          </>
      </div>
      )
    )
  };
}

export default EB01PrintContent;